// removed by extract-text-webpack-plugin
module.exports = {"pageSection":"pageSection-module_pageSection_2ki2P","gridContainer":"pageSection-module_gridContainer_2aIeW","borderTop":"pageSection-module_borderTop_32lgU","darkBackground":"pageSection-module_darkBackground_3eHIa","spaceBottom":"pageSection-module_spaceBottom_22EeD"};


//////////////////
// WEBPACK FOOTER
// ./client/pages/home/pageSection/pageSection.module.css
// module id = 468
// module chunks = 1 3